/**
 * The Column — iAdvocate brand mark. The "i" of iAdvocate as a classical
 * column: abacus capital (the dot), fluted shaft, torus, stepped plinth.
 *
 * Pure geometry, no font dependency. Fills with `currentColor`; the flutes are
 * cut out of the shaft (fill-rule evenodd) so the background shows through on
 * any surface — parchment or the dark chamber rail alike.
 *
 * Canonical source: corporate-web/src/components/common/ColumnMark.tsx — keep
 * the two files geometry-identical.
 *
 * viewBox is cropped to the ink (184×312) so sizing by height gives a tight
 * glyph: e.g. `className="h-9 w-auto text-brass"`.
 */
export default function ColumnMark({ className = '' }: { className?: string }) {
  return (
    <svg
      viewBox="184 88 144 312"
      className={className}
      fill="currentColor"
      aria-hidden
    >
      {/* abacus · echinus */}
      <path d="M192 88h128v24H192zM208 120h96v16h-96z" />
      {/* shaft with flutes cut out */}
      <path
        fillRule="evenodd"
        d="M216 144h80v200h-80zm24 8v184h6V152h-6zm26 0v184h6V152h-6z"
      />
      {/* torus · plinth */}
      <path d="M200 352h112v20H200zM184 380h144v20H184z" />
    </svg>
  );
}
